import { render, staticRenderFns } from "./DeliverableEditForm.vue?vue&type=template&id=592206f8"
import script from "./DeliverableEditForm.vue?vue&type=script&lang=js"
export * from "./DeliverableEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports